import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect, Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';

import './App.scss';
import '../styles/globalStyle.scss';
import Nav from './navigation/Nav';
import { connect } from 'react-redux';
import Overview from './overview/Overview';
import Labelling from './labelling/Labelling';
import Login from './login/Login';
import ForgotPassword from './login/forgot-password/ForgotPassword';
import PasswordReset from './login/password-reset/PasswordReset';
import Settings from './settings/Settings';
import QualityAssessment from './quality-assessment/QualityAssessment';
import UserManagement from './user-management/UserManagement';
import SFM from './sfm/SFM';
import Chat from './chat/Chat';
import Callbot from './callbot/Callbot';
import LiveClient from './live-client/Client';
import Export from './export';
import ChatDraftProvider from './utils/chat-draft/ChatDraftProvider';

// TODO: Uncomment for notifications
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import authActions from '../action-creators/authActions';
import cleanUpActions from '../action-creators/cleanupActions';
import Metrics from './metrics/Metrics';
import CallbotMetrics from './callbot-metrics/Metrics';
import OverviewMock from './overview-mock/OverviewMock';
import CallbotWidget from '../../sfm-app/components/callbot-test-client/CallbotWidget';
import CleanUpService from '../services/CleanupService';
import withChatDraft from './utils/chat-draft/withChatDraft';

const ENABLE_OVERVIEW_MOCK = process.env.ENABLE_OVERVIEW_MOCK || 'false';
const ENABLE_CS_ASSIST = process.env.ENABLE_CS_ASSIST || 'false';
const ENABLE_SIDEBAR = process.env.ENABLE_SIDEBAR || 'true';
const ENABLE_HEADER = process.env.ENABLE_HEADER || 'true';
const ENABLE_OVERVIEW = process.env.ENABLE_OVERVIEW || 'true';
const ENABLE_LABELLING = process.env.ENABLE_LABELLING || 'true';
const ENABLE_LIVE_CLIENT = process.env.ENABLE_LIVE_CLIENT || 'true';
const ENABLE_MANAGEMENT = process.env.ENABLE_MANAGEMENT || 'true';
const ENABLE_SETTINGS = process.env.ENABLE_SETTINGS || 'true';
const ENABLE_STATISTICS = process.env.ENABLE_STATISTICS || 'true';
const ENABLE_SFM = process.env.ENABLE_SFM || 'true';
const ENABLE_LIVE_CHAT = process.env.ENABLE_LIVE_CHAT || 'true';
const ENABLE_EXPORT = process.env.ENABLE_EXPORT || 'true';
const REDIRECT_URL = process.env.REDIRECT_URL || '/';
const REQUIRE_AUTH = process.env.REQUIRE_AUTH || 'true';
const SFM_ROUTES = process.env.SFM_ROUTES || '["/sfm"]';
const SEGMENTS = JSON.parse(process.env.SEGMENTS || '["Anonymous", "Logged-in"]');
const DEFAULT_SEGMENT = process.env.DEFAULT_SEGMENT || 'Anonymous';

const headerMenuOptions = {
  management: 'Management',
  callbot: 'CS assist tool',
  chat: 'Live Chat',
  draft_chat: 'Draft Live Chat',
  'live-client-testing': 'Live Client Testing',
  login: ENABLE_CS_ASSIST == 'true' ? 'Callbot login' : 'Chatbot login',
};
const App = ({ navLinks, loading, user, logout, appCleanup }) => {
  if (loading) return <div>Loading ...</div>;
  const cleanup = withChatDraft(() => {
    useEffect(() => {
      appCleanup();
    }, []);

    return <div>Cleaning and Initializing...</div>;
  });
  const location = useLocation();
  if (REQUIRE_AUTH === 'true' && !user) {
    if (location.pathname == '/login') document.title = headerMenuOptions['login'];

    return (
      <>
        <NotificationContainer />

        <div id="app-container">
          <div id="app-router-wrapper">
            <Switch>
              <Route exact path="/login" component={Login} />
              <Route exact path="/forgot-password" component={ForgotPassword} />
              <Route exact path="/password-reset" component={PasswordReset} />
              <Route path="/">
                <Redirect to="/login" />
              </Route>
            </Switch>
          </div>
        </div>
      </>
    );
  }
  let selectedMenu = 'management';
  if (['/chat', '/callbot', '/live-client-testing', '/draft_chat'].includes(location.pathname))
    selectedMenu = location.pathname.substring(1);
  document.title = headerMenuOptions[selectedMenu];
  return (
    <>
      <NotificationContainer />
      {ENABLE_HEADER === 'true' ? (
        <div id="app-header">
          <div id="app-header-logo">
            <svg width="172" height="32" viewBox="0 0 172 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M169.624 25.3784L171.687 25.7436V7.1709L169.573 7.53604V20.9961C169.567 21.2231 169.584 21.4502 169.624 21.6738L159.208 7.58821L159.158 7.53604L157.096 7.1709V25.7958H157.246L159.208 25.4828V11.9184C159.217 11.7085 159.2 11.4983 159.158 11.2924L169.624 25.3784Z"
                fill="#002348"
              />
              <path
                d="M140.548 25.5581C140.601 25.5059 140.601 25.4548 140.653 25.4031L142.374 20.9592H150.775L152.496 25.4031C152.496 25.4548 152.548 25.5059 152.601 25.5581L155.314 25.9715L148.01 7.83434L145.818 7.47266H145.297L137.836 25.9715H137.888L140.548 25.5581ZM146.026 11.6065C146.131 11.3998 146.496 10.2113 146.548 9.84962C146.685 10.4518 146.877 11.0399 147.123 11.6065L150.044 19.1507H143.053L146.026 11.6065Z"
                fill="#002348"
              />
              <path
                d="M138.34 7.47266H125.125L125.416 9.59122H130.692V25.9715H133.015V9.59122H138.63V9.43594L138.34 7.47266Z"
                fill="#002348"
              />
              <path d="M121.947 25.9715V7.47266L119.563 7.83778V25.554L121.947 25.9715Z" fill="#002348" />
              <path
                d="M117.668 7.47266H103.675L104.032 9.6033H109.599V25.6071L112.05 25.9715V9.6033H117.975V9.44722L117.668 7.47266Z"
                fill="#002348"
              />
              <path
                d="M101.082 12.4919C100.645 11.3019 100.06 10.3194 99.3413 9.57209C98.5754 8.7711 97.6519 8.13742 96.629 7.71095C95.6118 7.28818 94.4477 7.07397 93.1684 7.07397H86.5928V25.5654H93.1684C94.4477 25.5654 95.6118 25.3512 96.6227 24.9309C97.6277 24.5329 98.5169 23.9232 99.3413 23.0672C100.102 22.2762 100.672 21.3194 101.084 20.1418C101.492 18.9762 101.69 17.7262 101.69 16.3198C101.69 14.9134 101.492 13.6631 101.082 12.4919ZM99.3913 19.5132C99.086 20.3546 98.6167 21.127 98.0106 21.7856C97.4307 22.3986 96.7237 22.8773 95.9393 23.1882C95.1136 23.5074 94.2036 23.6625 93.1576 23.6625H88.4114V8.97678H93.1576C94.2495 8.97678 95.1568 9.13107 95.9321 9.44821C96.724 9.76189 97.4374 10.2457 98.0218 10.8654C98.5962 11.4359 99.0314 12.1542 99.3913 13.1261C99.7098 13.9843 99.8711 15.0334 99.8711 16.2446C99.8711 17.3075 99.7246 18.2947 99.3913 19.5132V19.5132Z"
                fill="#002348"
              />
              <path
                d="M79.9275 21.769L69.3666 7.51139C69.2878 7.40766 69.0772 7.15224 68.9936 7.12488C68.8822 7.08846 68.8071 7.07398 68.5278 7.07398H67.5264V25.566H69.4283V10.8665L80.0438 25.1345C80.1269 25.2673 80.2426 25.3766 80.3798 25.4522C80.5171 25.5277 80.6714 25.5669 80.828 25.566H81.8294V7.07397H79.9275V21.769Z"
                fill="#002348"
              />
              <path d="M62.7624 7.07397H61.1709V25.566H62.7624V7.07397Z" fill="#002348" />
              <path
                d="M55.8913 7.07377C55.7435 7.07042 55.5962 7.0922 55.4557 7.13819C55.3019 7.23527 55.1755 7.37002 55.0885 7.52965L48.1719 19.7718C48.1692 19.775 48.1665 19.7781 48.1638 19.7808L41.0499 7.54677C41.0309 7.50938 40.8773 7.21837 40.6165 7.14269C40.4796 7.09008 40.3332 7.06661 40.1867 7.07377H38.9268V25.5658H40.8386V10.9195L47.1876 21.9287L47.2137 21.9688C47.2998 22.0832 47.561 22.4314 48.039 22.4314H48.2417C48.4168 22.4343 48.5893 22.3886 48.74 22.2994C48.8907 22.2101 49.0137 22.0809 49.0954 21.926L55.2899 10.9952V25.5658H57.2017V7.07377H55.8913Z"
                fill="#002348"
              />
              <path
                d="M31.5908 28.261C31.1714 25.3375 30.4452 18.3825 30.4452 18.3825C30.2939 16.8505 30.1844 15.7437 29.5389 14.3283C28.569 12.0871 27.1207 10.7515 26.0468 9.76133C23.9557 7.83103 21.4033 6.33906 18.4594 5.32639C18.3946 5.30413 18.3251 5.29896 18.2577 5.31136C18.1903 5.32376 18.1273 5.35332 18.0746 5.39719C18.022 5.44106 17.9815 5.49776 17.9571 5.56182C17.9328 5.62587 17.9253 5.69513 17.9355 5.7629L18.14 7.11748C18.1507 7.1881 18.1802 7.25454 18.2253 7.30986C18.2705 7.36518 18.3297 7.40733 18.3968 7.43191C20.7362 8.27966 22.8873 9.57658 24.7291 11.2497C25.6995 12.1452 26.9072 13.2597 27.7415 15.1328C28.2293 16.3004 28.3613 17.1663 28.4933 18.8204C28.5136 18.9411 28.96 23.3977 29.1226 24.7397C28.2415 23.6383 27.2469 22.4922 26.1549 21.3201C24.6323 19.6322 23.5331 18.6362 22.2312 17.7654C20.9384 16.9153 19.6135 16.2576 17.9414 15.6337C15.5719 14.7161 14.1812 14.4629 12.8348 14.2174C11.6626 14.0075 10.5923 13.7647 8.88273 13.207C7.17227 12.6241 4.11534 11.3826 2.86662 9.62799C2.49678 9.0721 1.9071 7.93149 2.11207 6.5269C2.17694 5.94083 2.33866 5.23584 3.45719 4.27452C4.25498 3.55016 5.07981 2.80146 8.05475 2.27666C12.6802 1.35138 16.7886 3.01995 18.1423 3.57043C21.656 4.95699 24.9129 7.33101 27.5608 10.4357C27.617 10.5016 27.6932 10.5474 27.7777 10.5662C27.8623 10.5849 27.9507 10.5756 28.0295 10.5397C28.1083 10.5037 28.1732 10.4431 28.2145 10.367C28.2557 10.2908 28.2711 10.2033 28.2582 10.1177L27.9307 7.9423C27.9181 7.85938 27.8798 7.78249 27.8212 7.72247C25.1602 5.0106 22.1529 2.99112 18.8838 1.72032C17.231 1.05767 12.8415 -0.703242 7.5768 0.304474C4.32121 0.909013 3.1342 1.80321 2.02378 2.82039C0.811544 3.90108 0.22187 4.94483 0.0529416 6.30707C-0.265095 8.67658 0.943534 10.483 1.18724 10.819C2.37199 12.4745 4.7361 13.9318 8.21828 15.1517C9.59682 15.6246 11.011 15.9863 12.4474 16.2333C13.6803 16.4581 14.9547 16.6901 17.2053 17.5672C18.8702 18.2042 19.9969 18.7632 21.0951 19.4966C22.0412 20.1295 22.9682 20.8958 24.6643 22.7585C27.6171 25.9893 29.129 28.2065 29.6254 28.935C29.6871 29.0251 31.3687 31.8058 31.3687 31.8058C31.4162 31.8853 31.4898 31.9458 31.5771 31.9769C31.6643 32.008 31.7596 32.0077 31.8466 31.9761C31.9336 31.9446 32.007 31.8837 32.054 31.804C32.101 31.7242 32.1188 31.6306 32.1043 31.5392C32.1043 31.5392 31.6007 28.3304 31.5908 28.261Z"
                fill="#E61A3C"
              />
            </svg>
          </div>

          <div className="app-header-actions">
            <Menu
              disabledOverflow={true}
              style={{ background: 'none', fontSize: '16px' }}
              selectedKeys={[selectedMenu]}
              mode="horizontal"
            >
              {ENABLE_CS_ASSIST === 'true' ? (
                <Menu.Item key="callbot">
                  <Link style={{ textDecoration: 'none' }} to="/callbot">
                    CS assist tool
                  </Link>
                </Menu.Item>
              ) : null}
              {ENABLE_LIVE_CLIENT === 'true' ? (
                <Menu.Item key="chat">
                  <Link style={{ textDecoration: 'none' }} to="/chat">
                    Live Chat
                  </Link>
                </Menu.Item>
              ) : null}
              {user.role === 'admin' ? (
                <Menu.Item key="draft_chat">
                  <Link style={{ textDecoration: 'none' }} to="/draft_chat">
                    Draft Live Chat
                  </Link>
                </Menu.Item>
              ) : null}
              {ENABLE_LIVE_CLIENT === 'true' && ['product_manager', 'admin'].includes(user.role) ? (
                <Menu.Item key="live-client-testing">
                  <Link style={{ textDecoration: 'none' }} to="/live-client-testing">
                    Live Client Testing
                  </Link>
                </Menu.Item>
              ) : null}
              {['customer_service_representative'].includes(user.role) ? null : (
                <Menu.Item key="management">
                  <Link style={{ textDecoration: 'none' }} to="/">
                    Management
                  </Link>
                </Menu.Item>
              )}
              <Menu.Item id="logout" key="logout" onClick={logout}>
                Log out
              </Menu.Item>
            </Menu>
          </div>
        </div>
      ) : null}

      <div id="app-container" style={{ height: ENABLE_HEADER === 'true' ? 'calc(100% - 80px)' : '100%' }}>
        {ENABLE_SIDEBAR === 'true' && !['/chat', '/callbot', '/draft_chat'].includes(location.pathname) ? (
          <div id="app-nav-wrapper">
            <Nav />
          </div>
        ) : (
          ''
        )}
        <div id="app-router-wrapper">
          <ChatDraftProvider>
            <Switch>
              {ENABLE_LIVE_CLIENT === 'true' ? (
                <Route exact path="/live-client-testing" component={LiveClient} />
              ) : null}
              <Route exact path="/draft_chat" render={props => <Chat key="/draft_chat" mode="draft" {...props} />} />
              {ENABLE_LIVE_CHAT === 'true' ? (
                <Route exact path="/chat" render={props => <Chat key="/chat" mode="live" {...props} />} />
              ) : null}
              {ENABLE_EXPORT === 'true' ? <Route exact path="/export" component={Export} /> : null}
              {ENABLE_OVERVIEW === 'true' ? (
                <Route exact path="/" component={ENABLE_OVERVIEW_MOCK === 'true' ? OverviewMock : Overview} />
              ) : null}
              {ENABLE_LABELLING === 'true' ? <Route exact path="/labelling" component={Labelling} /> : null}
              {ENABLE_CS_ASSIST === 'true' ? <Route exact path="/callbot" component={Callbot} /> : null}
              {ENABLE_MANAGEMENT === 'true' ? <Route exact path="/user-management" component={UserManagement} /> : null}
              {ENABLE_SETTINGS === 'true' ? <Route exact path="/settings" component={Settings} /> : null}
              {ENABLE_LABELLING === 'true' ? <Route exact path="/qa" component={QualityAssessment} /> : null}
              {ENABLE_CS_ASSIST === 'true' ? <Route exact path="/callbot-metrics" component={CallbotMetrics} /> : null}
              {ENABLE_STATISTICS === 'true' ? <Route exact path="/metrics" component={Metrics} /> : null}
              {ENABLE_SFM === 'true'
                ? JSON.parse(SFM_ROUTES).map(route => <Route key={route} exact path={route} component={SFM} />)
                : null}
              <Route path="/initialize" component={cleanup} />
              <Route path="/">
                <Redirect to={REDIRECT_URL} />
              </Route>
            </Switch>
          </ChatDraftProvider>
        </div>
      </div>
    </>
  );
};

export const mapStateToProps = state => {
  return {
    navLinks: state.nav.links,
    loading: !state.auth.ready,
    user: state.auth.user,
  };
};

const mapDispatchToProps = {
  logout: authActions.userLogout,
  appCleanup: cleanUpActions.appCleanup,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
